import type {PageLoad} from './$types';

export const load: PageLoad = () => {
    return {
        page_title: "Client Info",
    };

};